import { clsx } from 'clsx';
import { Pagination, type PaginationProps } from './Pagination';

type PaginatedListFooterProps = PaginationProps & {
  wrapperClassName?: string;
};

export function PaginatedListFooter({
  wrapperClassName,
  ...paginationProps
}: PaginatedListFooterProps) {
  return (
    <div className={clsx('px-5 pt-6', wrapperClassName)}>
      <Pagination {...paginationProps} />
    </div>
  );
}
